import { useContext } from "react";
import Block from "components/layout/Block";
import Spacer from "components/layout/Spacer";
import Login from "components/user/Login";
import UserAvatar from "components/user/UserAvatar";
import generatePath from "utils/generatePath";
import routes from "containers";
import { VIP_STATUS } from "helpers/constants";
import deviceTypeContext from "contexts/deviceTypeContext";

// ** Third Party Components
import styled, { css } from "styled-components";

// #####################################################

export const StyledCommentContainer = styled(Block)`
	${({ $addBgColor }) =>
		$addBgColor &&
		css`
			background-color: ${({ theme: { colors } }) =>
				colors.buttonsDefaultGrey};
			padding: 0.75rem;

			box-shadow: var(--dz-sys-card-shadow);
			border: 1px solid var(--dz-sys-card-shadow-border);

			border-radius: ${({ theme: { borderRadius } }) =>
				borderRadius.card};
		`}

	${({ $changeSizeOfContent }) =>
		$changeSizeOfContent &&
		css`
			width: 100%;
		`}
`;

// #####################################################

const CustomUserMediaSkeletor = ({
	user,
	size,
	link,
	fullContent,
	content,
	headerLeft,
	closeModal,
	alignCenter,
	oneLine,
	noMarginBottom,
	paddingTop = null,
	noFull = false,
	vipProps,
	loginSize = null,
	maxWidthWithEllipsis = null,
	addBgColor = false,
	changeSizeOfContent = false,
	withBoxShadow = false,
	customOnlineCirclePosition,
	noOnlineCircle = false,
	checkboxComponent,
	...rest
}) => {
	const to = generatePath(routes.user.path, {
		login: user.login?.toLowerCase(),
	});
	const { isPhone } = useContext(deviceTypeContext);

	// #####################################################

	return (
		<Block
			full={!noFull}
			pt={paddingTop}
			mb={!noMarginBottom && 3}
			style={{ minWidth: "0" }} // Fixes for "maxWidthEllipsis" without limit in mobile.
		>
			<Block
				flex
				full
				justifyStart
				alignStart
				alignCenter={alignCenter}
				mb={fullContent ? 2 : null}
				style={{ minWidth: "0" }}
			>
				<Block flex full column style={{ minWidth: "0" }}>
					<Block flex alignCenter>
						<Block mr={3} flex style={{ userSelect: "none" }}>
							{checkboxComponent && checkboxComponent()}
							<UserAvatar
								userId={user?.user_id || user?.id}
								src={user.avatar}
								login={user.login}
								online={user.online}
								privateData={
									user.private_data || user.privateData
								}
								status={
									user.profileStatus || user.profile_status
								}
								link={link}
								closeModal={closeModal}
								to={to}
								size={size}
								scrollForce
								customOnlineCirclePosition={
									customOnlineCirclePosition
								}
								noOnlineCircle={noOnlineCircle}
							/>
						</Block>
						<Block style={{ minWidth: "0" }}>
							<StyledCommentContainer
								flex
								column
								$addBgColor={addBgColor}
								style={{ minWidth: "0" }}
								$changeSizeOfContent={changeSizeOfContent}
								className={
									withBoxShadow ? "withBoxShadow" : null
								}
							>
								<Block flex justifyBetween alignCenter>
									<Block style={{ minWidth: "0" }}>
										<Login
											login={user.login}
											vip={
												user?.showStatusVip === false
													? user.status_vip >
														VIP_STATUS.VERIFIED
														? VIP_STATUS.VERIFIED
														: user.status_vip
													: user.status_vip
											}
											link={link}
											closeModal={closeModal}
											size={
												loginSize !== null
													? loginSize
													: size
											}
											scrollForce
											oneLine={oneLine}
											vipProps={vipProps}
											{...rest}
										/>
									</Block>
									<Spacer />
								</Block>
								{headerLeft ? headerLeft : null}
							</StyledCommentContainer>
						</Block>
					</Block>
					<Block style={{ marginLeft: "80px", marginTop: "0.25rem" }}>
						{content}
					</Block>
				</Block>
			</Block>
		</Block>
	);
};

// #####################################################

export default CustomUserMediaSkeletor;

// #####################################################
